import styled from "styled-components";
import colors from "../../../../../../../../core/styles/colors";

export const EduCreditInfo = styled.div`
  width: fit-content;
  max-width: 450px;
  background-color: ${colors.white.general};
  border: 1px solid ${colors.white.hoverWhite3};
  border-radius: 10px;

  padding: 4px 12px;
  margin-top: 8px;

  font-size: 14px;
  font-weight: 300;

  span {
    color: ${colors.red.general};
  }
`;
